export enum WALLET_TYPES {
	LOCAL = "NAIRA",
	GLOBAL = "DOLLAR",
}
